import { DateTime } from 'luxon';

export default {
  methods: {
    formatInterval(interval) {
      const intervalDateTime = DateTime.fromJSDate(interval.date, { zone: this.timezone });
      const timeParts = intervalDateTime.toFormat('HH:mm').split(':');

      // This formats the hours on the grid,
      // We always want to show all the hours as if there is no DST
      const tz = 'UTC';
      let intervalLabel = this.novaCore.formatDateTimeWithMilitarySupport(
        `${intervalDateTime.toISODate()}T${intervalDateTime.toFormat('HH:mm:ss')}`,
        tz,
        this.novaCore.LuxonDateTimeFormats.Hour12,
        this.$isMilitaryTimeEnabled(this.$selectedWarehouse),
        this.novaCore.LuxonDateTimeFormats.Extended24HrTime,
        this.$i18n.locale
      );

      if (timeParts[1] !== '00') {
        intervalLabel = timeParts[1];
      }
      return intervalLabel;
    }
  }
};
